/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Deep",
  logo_name: "Deep()",
  // nickname: "harry / picleric",
  full_name: "Deep Ramani",
  subTitle: "ReactJS Developer, Web Developer.",
  resumeLink:
    "https://drive.google.com/file/d/1kSDDvEtnDMr6hlNE7Ilurvg-hiY73JW1/view?usp=sharing",
  mail: "mailto:deepramani8505@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/Deep-Ramani/",
  linkedin: "https://www.linkedin.com/in/deep-ramani-486954202/",
  gmail: "deepramani8505@gmail.com",
  // gitlab: "https://gitlab.com/harikanani",
  // facebook: "https://www.facebook.com/vedansh.vijaywargiya/",
  // twitter: "https://twitter.com/vedansh_v_/",
  instagram: "https://www.instagram.com/dsp_ramani/",
};

// Follow this link to add any icons in future
// https://iconify.design/
const skills = {
  data: [
    {
      title: "Web Developer",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive User Interfaces for web applications",
        "⚡ Building responsive website front end using ReactJS",
        // "⚡ Integration of third party services such as Firebase/ AWS / GCP",
        "⚡ Love bringing designs to life and creating beautiful, usable experiences for all users",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "file-icons:nextjs",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "logos:gatsby",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        // {
        //   skillName: "NodeJS",
        //   fontAwesomeClassname: "simple-icons:node-dot-js",
        //   style: {
        //     color: "#339933",
        //   },
        // },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        // {
        //   skillName: "Flask",
        //   fontAwesomeClassname: "simple-icons:flask",
        //   style: {
        //     color: "#000000",
        //   },
        // },
        // {
        //   skillName: "Django",
        //   fontAwesomeClassname: "simple-icons:django",
        //   style: {
        //     color: "#0c4b33",
        //   },
        // },
        // {
        //   skillName: "MongoDB",
        //   fontAwesomeClassname: "simple-icons:mongodb",
        //   style: {
        //     color: "#439743",
        //   },
        // },
        // {
        //   skillName: "Android",
        //   fontAwesomeClassname: "simple-icons:android",
        //   style: {
        //     color: "#3DDC84",
        //   },
        // },
        // {
        //   skillName: "Java",
        //   fontAwesomeClassname: "simple-icons:java",
        //   style: {
        //     color: "#f89820",
        //   },
        // },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
        // {
        //   skillName: "Dart",
        //   fontAwesomeClassname: "simple-icons:dart",
        //   style: {
        //     color: "#29B0EE",
        //   },
        // },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        // {
        //   skillName: "Wordpress",
        //   fontAwesomeClassname: "simple-icons:wordpress",
        //   style: {
        //     color: "#207297",
        //   },
        // },
        // {
        //   skillName: "Apache",
        //   fontAwesomeClassname: "simple-icons:apache",
        //   style: {
        //     color: "#CA1A22",
        //   },
        // },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        // {
        //   skillName: "Python",
        //   fontAwesomeClassname: "simple-icons:python",
        //   style: {
        //     color: "#3776AB",
        //   },
        // },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        // {
        //   skillName: "PostgreSQL",
        //   fontAwesomeClassname: "simple-icons:postgresql",
        //   style: {
        //     color: "#336791",
        //   },
        // },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
        // {
        //   skillName: "GitHub Actions",
        //   fontAwesomeClassname: "simple-icons:githubactions",
        //   style: {
        //     color: "#5b77ef",
        //   },
        // },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Marwadi Education Foundation Group of Institution",
      subtitle: "Bachelors in Computer Engineering",
      logo_path: "mu-logo.png",
      alt_name: "SSEC",
      duration: "2019 - 2022",
      descriptions: [
        // "⚡  I'm currently pursuing my Bachelors in Computer Science and Engineering.",
        // "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        // "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        // "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "https://www.marwadiuniversity.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Hackathon",
      subtitle: "AVYAM (Hackathon)",
      logo_path: "Hackathon-logo-1.png",
      certificate_link:
        "https://drive.google.com/file/d/1wMpVKrogOVzKu_v4DuwXC01UKibqJfJp/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "#ffffff",
    },
    {
      title: "Courses",
      subtitle: "Algorithmic toolbox",
      logo_path: "Algorithmic toolbox.png",
      certificate_link:
        "https://drive.google.com/file/d/1u7sTIYszm7vpZtUZ6g3hrxBHw3Nk1osa/view?usp=sharing",
      alt_name: "hackathon",
      // color_code: "#f47e2c",
      color_code: "#fbc6ba",
    },
    {
      title: "Courses",
      subtitle: "Blockchain",
      logo_path:
        "bitcoin-cryptocurrency-vault-safelock_SOIN20003_905168316_is_1560x880.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1PU5AtGemnfzDEnSZYUm3pSFCWbA3pMXw/view?usp=sharing",
      alt_name: "hackathon",
      color_code: "#2c829c",
    },

    // {
    //   title: "A300: Atlas Security",
    //   subtitle: "MongoDB University",
    //   logo_path: "mongo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/12u_tkvhgB-K2TIm-RDdJOwYbQ9ccqiqA/view?usp=sharing",
    //   alt_name: "MongoDB University",
    //   // color_code: "#F6B808",
    //   color_code: "#47A048",
    // },
    {
      title: "Courses",
      subtitle: "Design Thinking of Innovation",
      logo_path: "cpm-design-thinking-opener-1024x731.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1AQ7DnQeb-JKNUtY0DT8VoSB2l2pYVkO8/view?usp=sharing",
      alt_name: "Opensource Event",
      color_code: "#312f30",
    },
    // {
    //   title: "MLH Local Hack Day: Build",
    //   subtitle: "Major League Hacking",
    //   logo_path: "mlh-logo.svg",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1ws7g2Oepu76vDFir6SvR_emFAMSkB2ZQ/view?usp=sharing",
    //   alt_name: "Google",
    //   color_code: "#fe0037",
    // },
    {
      title: "Student Ambassador",
      subtitle: "Microsoft Student Ambassador",
      logo_path: "microsoftstudentambassador.png",
      certificate_link:
        "https://drive.google.com/file/d/11Ifs4qJGiWeBDGaN2ZT-mt51V9YkocYJ/view?usp=sharing",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Courses",
      subtitle: "Networking Essentials",
      logo_path: "cisconetworking.png",
      certificate_link:
        "https://drive.google.com/file/d/1cBnqCsoGQa7o3JEH8KzOhgBaidm4CrRn/view?usp=sharing",
      alt_name: "Reply",
      color_code: "#244f7b",
    },
    {
      title: "Courses",
      subtitle: "Introduction to Packet Traser",
      logo_path: "packettracer.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1Riuuitp_JGpja7iQiQf8sSwGk87FFS8S/view?usp=sharing",
      alt_name: "Reply",
      color_code: "#04b4bb",
    },
    {
      title: "Courses",
      subtitle: "Introducation to IOT",
      logo_path: "Introduction_to_IoT.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1FHZ6rAr2Nk915dxn-oWQoRzIJniI5h4P/view?usp=sharing",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#25739a",
    },
    {
      title: "Courses",
      subtitle: "Passport to Communication",
      logo_path: "communication.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/1Y_crhKvFxvLvTO8l-1IdMvpSUGs1AMvQ/view?usp=sharing",
      alt_name: "Reply",
      color_code: "#eddbc3",
    },
    {
      title: "Courses",
      subtitle: "Fundamentals of scable data science",
      logo_path: "datascience1.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1t-gQQDXT1YGfn5uzwUhMoiTOixMTZFHj/view?usp=sharing",
      alt_name: "Reply",
      color_code: "#000f28",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed one internship. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Web Developer Intern",
          company: "Tark Technologies",
          company_url: "https://tarktech.com/",
          logo_path: "Tark.png",
          duration: "May 2021 - June 2021",
          location: "Remote",
          // description: `Analysed the changes before and after people started using sanitizers using the covid-19 dataset. Built and analysed several predictive models for defaulting user’s credit card and deployed it on a full-stack website using Flask. Made a predictive model for Blood Donation for Future Expectancy and deployed it on a fully-fledged website. Increased productivity and problem-solving technics by 20%.
          // `,
          // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        },
        // {
        //   title: "Data Science Intern",
        //   company: "The Sparks Foundation",
        //   company_url: "hhttps://thesparksfoundation.info/",
        //   logo_path: "TSF.png",
        //   duration: "Aug 2020 - Sept 2020",
        //   location: "Remote",
        //   description: `Developed predictive models and deployed it on a full-stack website using Flask. Used Boxplot, Heatmap and Confusion Matrix for data visualization. Deep analysis on the superstore dataset using Bar Plots, Bar Charts, Pair Plots and Joint Plots for specific regions.
        //   `,
        //   // "Created Front end of Yearn Financial Mutual Funds website. also degined simple web application for better user experience, designed DB Schemas as well.",
        //   color: "#ee3c26",
        // },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Microsoft Student Ambassador",
          company: "Microsoft",
          // company_url: "https://www.webarchsrm.com/",
          logo_path: "LevelAlpha.png",
          // duration: "Mar 2020 - Nov 2020",
          // location: "SRM IST Kattankulathur",
          // description:
          //   "Member responsibilities were to help students in project planning, review issues and pull requests, ensure smooth progress and help juniors out in their difficulties.",
          color: "#4285F4",
        },
        {
          title: "Placement Co-Ordinator",
          company: "Marwadi University",
          company_url: "https://www.marwadiuniversity.ac.in/",
          logo_path: "mu-logo (copy).png",
          // duration: "Nov 2020 - Present",
          // location: "SRM IST Kattankulathur",
          // description:
          //   "Held numerous workshops and distributed learning content for freshers. Contributed to development of the causefolio website displaying the information about the Code for Cause Community.",
          color: "#a60000",
        },
        {
          title: "TechnoSpark 2020 Event Organizer",
          company: "Christ Polytechnic Institute",
          company_url: "https://christpolytechnicrajkot.edu.in/",
          logo_path: "christ.jpeg",
          // duration: "Oct 2020 - Present",
          // location: "SRM IST Kattankulathur",
          // description:
          //   "Associate responsibilities were to build fast and efficient machine learning models, have talks on research topics related to computer vision and deep learning. Build team projects and intract with fellow members and ensure smooth progress and help juniors out in their difficulties.",
          color: "#62cff0",
        },
        {
          title: "SSIP Hackathon Event Co-ordinator",
          company: "SSIP",
          company_url: "http://www.ssipgujarat.in/",
          logo_path: "hackathon.jpg",
          // duration: "Dec 2020 - May 2021",
          // location: "Remote",
          // description:
          //   "Spread Awareness of new Technologies and Companies and new Opportunities to Students and Grow Bagcampus Community.",
          color: "#0059c9",
        },
        // {
        //   title: "Volunteer",
        //   company: "Google Crowdsource",
        //   company_url: "https://indiaenvironment.org/",
        //   logo_path: "GCS.jfif",
        //   duration: "Sept 2020 - Present",
        //   location: "Remote",
        //   description:
        //     "As a member of the global Crowdsource community one can gain recognition from other Crowdsourcers and Google.",
        //   color: "#ffffff",
        // },
        // {
        //   title: "Student Volunteer",
        //   company: "National Service Scheme",
        //   company_url: "https://indiaenvironment.org/",
        //   logo_path: "NSS.jfif",
        //   duration: "Dec 2019 - May 2020",
        //   location: "SRM IST Kattankulathur",
        //   description:
        //     "Take time out over weekends to join a gang of nation builders, nature enthusiasts to conserve what is left.",
        //   color: "#282b6c",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create NodeJS Backend Projects, Python Scripts, and React Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "avatar2.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others.",
    // link: "https://medium.com/@vedanshvijay/",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Developers Community",
      url: "https://github.com/Deep-Ramani/Developers---Community/",
      description:
        "This is website where develoepr can join the community. In this website developer create their profile and also developer create post and also like and comment on another post.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Mongodb",
          iconifyClass: "vscode-icons:folder-type-mongodb-opened",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos:nodejs-icon",
        },
        // {
        //   name: "Python",
        //   iconifyClass: "logos-python",
        // },
        // {
        //   name: "Flask",
        //   iconifyClass: "cib-flask",
        // },
      ],
    },
    {
      id: "1",
      name: "Caffeine Rush",
      url: "https://github.com/Deep-Ramani/js-project",
      description:
        "A Website where user can buy and order coffee and many more things. Another one is user can also book the table. ",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "PHP",
          iconifyClass: "vscode-icons:file-type-php2",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "2",
      name: "Blog App",
      url: "https://github.com/Deep-Ramani/Blog_App",
      description:
        "A Blog App where user can create theire blog and post that blog. User read the blog and also comment on that blog.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "bxl:tailwind-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "GraphQL",
          iconifyClass: "logos:graphql",
        },
        {
          name: "NextJS",
          iconifyClass: "logos:nextjs-icon",
        },
      ],
    },
    {
      id: "3",
      name: "Jingle Music Player",
      // url: "https://github.com/vvHacker007/Event-Scheduler",
      description:
        "This is a website where user listen the latest all the types of songs and also user can add playlist and add any song as a favourite. Also user can download any song on their local storage.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "PHP",
          iconifyClass: "vscode-icons:file-type-php2",
        },
      ],
    },
    {
      id: "4",
      name: "ToDO List App",
      url: "https://deep-ramani.github.io/React_ToDoList_App/",
      description:
        "A todo list app where user can add , delete item as per requirements.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "3",
      name: "Image Maker",
      url: "https://github.com/Deep-Ramani/imagemaker",
      description:
        "Website where user can create any image using the given tools ",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        // {
        //   name: "Python",
        //   iconifyClass: "logos-python",
        // },
        // {
        //   name: "Flask",
        //   iconifyClass: "cib-flask",
        // },
      ],
    },
    {
      id: "4",
      name: "Scientific Calculator",
      url: "https://deep-ramani.github.io/js-practical/",
      description:
        "Made a GUI based Calculator. Also made an executable file for the project which can be downloaded and used by anyone on their personal computer.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "5",
      name: "UserList React App",
      url: "https://userlist-react-application.netlify.app/",
      description:
        "A user list app that displays all the users and when we hover any user then display all information of the user on card.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "6",
      name: "User Management App",
      url: "https://usermanagementreactapp.netlify.app/signupPage",
      description:
        "React App where user can signup and display the user details",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Netlify",
          iconifyClass: "logos:netlify",
        },
      ],
    },
    // {
    //   id: "7",
    //   name: "Steganography",
    //   url: "https://github.com/vvHacker007/Steganography",
    //   description:
    //     "A CLI tool to conceal messages within a file, text, image, or video.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "OpenCV",
    //       iconifyClass: "logos-opencv",
    //     },
    //   ],
    // },
    // {
    //   id: "8",
    //   name: "Mini Paint",
    //   url: "https://github.com/vvHacker007/Mini-Paint",
    //   description: "GUI based Mini Paint Application.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "9",
    //   name: "Speedtest",
    //   url: "https://github.com/vvHacker007/Speed-test",
    //   description:
    //     "An internet speed testing application which can notify about the download speed, upload speed, and also the reaction time of the connection.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "10",
    //   name: "Cat Classifier",
    //   url: "https://github.com/vvHacker007/Cat-Classifier",
    //   description:
    //     "Binary Cat Classifier made by hard coding Neural Networks in Python without using libraries such as Tensorflow or keras.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   id: "11",
    //   name: "Snake",
    //   url: "https://github.com/vvHacker007/Snake",
    //   description:
    //     "A snake game which covers all the basic features like score, high score and an automated speed increase simultaneously when the snake eats the food.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "12",
    //   name: "Score Predictor",
    //   url: "https://score-predictor-app.herokuapp.com/",
    //   description:
    //     "Predicts students score based on the number of hours the student puts in it.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   id: "13",
    //   name: "Blood Donation Predictor",
    //   url: "https://blood-donation-predictor-app.herokuapp.com/",
    //   description:
    //     "Predicts if one is ready to donate blood based on the user's blood donation history.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   id: "14",
    //   name: "Credit-Card Default Predictor",
    //   url: "https://default-predictor-app.herokuapp.com/",
    //   description:
    //     "Predicts whether user's credit card would be defaulted or not based on the user's bank statements and history.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    {
      id: "15",
      name: "Portfolio Website",
      // url: "https://vvhacker007.github.io/Portfolio/",
      description: "You are stalking it right now 😉",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
